import { useMutation, useQueryClient } from "@tanstack/react-query";

import { tillsKeys } from "../../tills/keys";
import { updateSession } from "../requests";
import { sessionsKeys } from "../keys";

export function useCloseSession() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateSession,
    onSuccess: async (_, { sessionId, tillId }) => {
      await queryClient.invalidateQueries({
        queryKey: tillsKeys.detail(tillId)
      });
      await queryClient.invalidateQueries({
        queryKey: tillsKeys.list({})
      });
      await queryClient.invalidateQueries({
        queryKey: sessionsKeys.list({ tillId })
      });
      await queryClient.invalidateQueries({
        queryKey: sessionsKeys.detail({ sessionId, tillId })
      });
    }
  });
}
